"use strict";

class sessionStorageGuidCookie {

    assign() {
        let guIdName = 'journeyId';
        let match = document.cookie.match(new RegExp(guIdName + '=([^;]+)'));
        if(match.length){
            sessionStorage.setItem(guIdName, match[1]);
        }
    }
}

module.exports = sessionStorageGuidCookie;


